import Navbar from "components/navbar/Navbar";
import { FC, useState } from "react";
import AIBanner from "components/worth-it-builder/AIBanner";
import { useRouter } from "next/router";
import { Box } from "@mui/material";

const AiBuilderSection: FC = () => {
  const router = useRouter();

  const [nothingToShow, setNothingToShow] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState("");
  const [budgetValue, setBudgetValue] = useState("");

  const getAiBuildParam = (param) => {
    const query = param;
    if (query) {
      router.push(`ai-builder/search/${query}`);
    } else {
      setNothingToShow(true);
    }
  };

  return (
    <Box flex="1 1 auto" minWidth="0px" mt={4}>
      <AIBanner
        title="AI BUILDER"
        cover="/assets/images/banners/aiBG_update.png"
        hasSearch
        getAiBuildFunc={getAiBuildParam}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        budgetValue={budgetValue}
        setBudgetValue={setBudgetValue}
      />
    </Box>
  );
};

export default AiBuilderSection;
